import React from 'react'

import PropTypes from 'prop-types'

import './ambassadorsbtn-r.css'

const AmbassadorsbtnR = (props) => {
  return (
    <div className={`ambassadorsbtn-r-thq-images-elm ${props.rootClassName} `}>
      <div className="ambassadorsbtn-r-container1">
        <img
          alt={props.imageAlt1}
          src={props.imageSrc1}
          className="ambassadorsbtn-r-image1"
        />
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-r-icon1">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
      </div>
      <div className="ambassadorsbtn-r-container2">
        <img
          alt={props.imageAlt11}
          src={props.imageSrc11}
          className="ambassadorsbtn-r-image2"
        />
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-r-icon3">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
      </div>
    </div>
  )
}

AmbassadorsbtnR.defaultProps = {
  imageSrc11: '/nav patterns/consultancy.svg',
  imageAlt11: 'image',
  imageSrc1: '/nav patterns/consultancy.svg',
  rootClassName: '',
  imageAlt1: 'image',
}

AmbassadorsbtnR.propTypes = {
  imageSrc11: PropTypes.string,
  imageAlt11: PropTypes.string,
  imageSrc1: PropTypes.string,
  rootClassName: PropTypes.string,
  imageAlt1: PropTypes.string,
}

export default AmbassadorsbtnR
